<template>
  <div class="block__visual">
    <div class="mock lift-hover" :style="mockStyle">
      <img
        v-if="displayImage"
        :src="displayImage"
        :alt="altText"
        class="mock__img-fit"
        @load="onImageLoad"
      />
      <div v-else class="mock__placeholder">请在后台上传产品配图</div>
<!--      <img :src="headerLogo" alt="">-->
<!--      <div class="mock__tabs" aria-hidden="true">-->
<!--        <span class="mock__tab mock__tab&#45;&#45;on">MSKU</span>-->
<!--        <span class="mock__tab">ASIN</span>-->
<!--        <span class="mock__tab">SKU</span>-->
<!--        <span class="mock__tab">店铺</span>-->
<!--      </div>-->
<!--      <div class="mock__subtabs" aria-hidden="true">-->
<!--        <span class="mock__sub mock__sub&#45;&#45;on">平台收入</span>-->
<!--        <span class="mock__sub">平台支出</span>-->
<!--      </div>-->
<!--      <div class="mock__stage">-->
<!--        <div class="mock__grid" aria-hidden="true">-->
<!--          <span v-for="n in 12" :key="n" class="mock__cell" />-->
<!--        </div>-->
<!--        <img v-if="image" :src="image" :alt="altText" class="mock__img" />-->

<!--        <aside class="source-pop" aria-hidden="true">-->
<!--          <p class="source-pop__cap">数据来源</p>-->
<!--          <ul class="source-pop__list">-->
<!--            <li v-for="(row, ri) in sourceLabels" :key="ri" class="source-pop__row">-->
<!--              <span class="source-pop__chk" />-->
<!--              <span>{{ row }}</span>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </aside>-->

<!--        <div class="accent-node" aria-hidden="true">-->
<!--          <span class="accent-node__ring" />-->
<!--          <span class="accent-node__ico" />-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: ""
    },
    altText: {
      type: String,
      default: ""
    }
  },
  computed: {
    displayImage() {
      const val = this.image == null ? "" : String(this.image).trim();
      return val;
    },
    mockStyle() {
      return {
        aspectRatio: this.imageAspectRatio
      };
    }
  },
  data() {
    return {
      imageAspectRatio: "16 / 10",
      sourceLabels: ["订单汇总", "交易流水", "库存快照", "平台结算", "广告花费", "费用分摊"]
    };
  },
  watch: {
    displayImage() {
      this.imageAspectRatio = "16 / 10";
    }
  },
  methods: {
    onImageLoad(event) {
      const img = event && event.target;
      const naturalWidth = img && img.naturalWidth;
      const naturalHeight = img && img.naturalHeight;
      if (!naturalWidth || !naturalHeight) return;
      this.imageAspectRatio = `${naturalWidth} / ${naturalHeight}`;
    }
  }
};
</script>

<style scoped>
.block__visual {
  position: relative;
}

.mock {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 14px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 18px 44px rgba(15, 46, 102, 0.1);
  overflow: hidden;
}

.mock.lift-hover:hover {
  border-color: #cbd5e1;
}

.mock__img-fit {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.mock__tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px 6px;
  background: linear-gradient(180deg, #f8fafc, #f1f5f9);
  border-bottom: 1px solid #e2e8f0;
}

.mock__tab {
  font-size: 12px;
  padding: 5px 10px;
  border-radius: 6px;
  color: #64748b;
}

.mock__tab--on {
  color: var(--primary);
  font-weight: 600;
  background: #eff6ff;
}

.mock__subtabs {
  display: flex;
  gap: 16px;
  padding: 8px 14px;
  background: #fff;
  border-bottom: 1px solid #eef2f8;
}

.mock__sub {
  font-size: 12px;
  color: #94a3b8;
  padding-bottom: 6px;
  border-bottom: 2px solid transparent;
}

.mock__sub--on {
  color: var(--primary-dark);
  font-weight: 600;
  border-bottom-color: var(--primary);
}

.mock__stage {
  position: relative;
  aspect-ratio: 16 / 10;
  background: linear-gradient(160deg, #f8fafc 0%, #eef2ff 100%);
  overflow: hidden;
}

.mock__grid {
  position: absolute;
  inset: 12px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 8px;
  opacity: 0.35;
  pointer-events: none;
}

.mock__cell {
  border-radius: 4px;
  background: rgba(148, 163, 184, 0.25);
}

.mock__img {
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.96;
}

.mock__placeholder {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 180px;
  color: #94a3b8;
  font-size: 14px;
}

.source-pop {
  position: absolute;
  z-index: 2;
  top: 14px;
  right: 14px;
  width: min(52%, 220px);
  padding: 12px 14px 12px;
  border-radius: 10px;
  background: linear-gradient(180deg, var(--primary-light) 0%, var(--primary) 100%);
  color: #fff;
  box-shadow: 0 12px 28px rgba(37, 99, 235, 0.35);
  font-size: 12px;
  line-height: 1.45;
}

.source-pop__cap {
  margin: 0 0 8px;
  font-size: 11px;
  font-weight: 600;
  opacity: 0.92;
  letter-spacing: 0.04em;
}

.source-pop__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.source-pop__row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  opacity: 0.98;
}

.source-pop__row:last-child {
  margin-bottom: 0;
}

.source-pop__chk {
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  border-radius: 3px;
  border: 1px solid rgba(255, 255, 255, 0.85);
  background: rgba(255, 255, 255, 0.2);
  position: relative;
}

.source-pop__chk::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.accent-node {
  position: absolute;
  z-index: 2;
  right: 10%;
  bottom: 10%;
  width: 48px;
  height: 48px;
  pointer-events: none;
}

.accent-node::before {
  content: "";
  position: absolute;
  right: 100%;
  bottom: 70%;
  width: 72px;
  height: 40px;
  border: none;
  border-top: 1px dashed rgba(148, 163, 184, 0.7);
  border-right: 1px dashed rgba(148, 163, 184, 0.7);
  border-radius: 0 12px 0 0;
  transform: translate(8px, 10px);
}

.accent-node__ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: rgba(16, 185, 129, 0.2);
}

.accent-node__ico {
  position: absolute;
  inset: 8px;
  border-radius: 50%;
  background: linear-gradient(145deg, #34d399, #10b981);
  box-shadow: 0 6px 14px rgba(16, 185, 129, 0.35);
}

.accent-node__ico::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 16px;
  height: 12px;
  margin: -6px 0 0 -8px;
  border: 2px solid rgba(255, 255, 255, 0.95);
  border-radius: 2px;
  border-top: 0;
  box-sizing: border-box;
}

@media (max-width: 991px) {
  .source-pop {
    width: auto;
    max-width: 200px;
    right: 10px;
    top: 10px;
  }
}

@media (max-width: 575px) {
  .mock__tabs {
    gap: 4px;
  }

  .mock__tab {
    padding: 4px 8px;
    font-size: 11px;
  }
}
</style>
